// LEADERS
export const GET_LEADERS_ATTEMPT = "GET_LEADERS_ATTEMPT";
export const GET_LEADERS_SUCCESS = "GET_LEADERS_SUCCESS";
export const GET_LEADERS_FAILURE = "GET_LEADERS_FAILURE";

// SUPERVISORS
export const GET_SUPERVISORS_ATTEMPT = "GET_SUPERVISORS_ATTEMPT";
export const GET_SUPERVISORS_SUCCESS = "GET_SUPERVISORS_SUCCESS";
export const GET_SUPERVISORS_FAILURE = "GET_SUPERVISORS_FAILURE";

// SELLERS
export const GET_SELLERS_ATTEMPT = "GET_SELLERS_ATTEMPT";
export const GET_SELLERS_SUCCESS = "GET_SELLERS_SUCCESS";
export const GET_SELLERS_FAILURE = "GET_SELLERS_FAILURE";

// ACCOUNT
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT = "LOGOUT";

// ORDERS
export const GET_ORDERS_ATTEMPT = "GET_ORDERS_ATTEMPT";
export const GET_ORDERS_SUCCESS = "GET_ORDERS_SUCCESS";
export const GET_ORDERS_FAILURE = "GET_ORDERS_FAILURE";

// SELLER STATS
export const GET_SELLER_STATS_ATTEMPT = "GET_SELLER_STATS_ATTEMPT";
export const GET_SELLER_STATS_SUCCESS = "GET_SELLER_STATS_SUCCESS";
export const GET_SELLER_STATS_FAILURE = "GET_SELLER_STATS_FAILURE";

// SELLER ORDERS
export const GET_SELLER_ORDERS_ATTEMPT = "GET_SELLER_ORDERS_ATTEMPT";
export const GET_SELLER_ORDERS_SUCCESS = "GET_SELLER_ORDERS_SUCCESS";
export const GET_SELLER_ORDERS_FAILURE = "GET_SELLER_ORDERS_FAILURE";

// ORIGINS
export const GET_ORIGINS_ATTEMPT = "GET_ORIGINS_ATTEMPT";
export const GET_ORIGINS_SUCCESS = "GET_ORIGINS_SUCCESS";
export const GET_ORIGINS_FAILURE = "GET_ORIGINS_FAILURE";

// STATES
export const GET_STATES_ATTEMPT = "GET_STATES_ATTEMPT";
export const GET_STATES_SUCCESS = "GET_STATES_SUCCESS";
export const GET_STATES_FAILURE = "GET_STATES_FAILURE";

// CHANNELS
export const GET_CHANNELS_ATTEMPT = "GET_CHANNELS_ATTEMPT";
export const GET_CHANNELS_SUCCESS = "GET_CHANNELS_SUCCESS";
export const GET_CHANNELS_FAILURE = "GET_CHANNELS_FAILURE";

// CLIENTS
export const GET_CLIENTS_ATTEMPT = "GET_CLIENTS_ATTEMPT";
export const GET_CLIENTS_SUCCESS = "GET_CLIENTS_SUCCESS";
export const GET_CLIENTS_FAILURE = "GET_CLIENTS_FAILURE";

// OPERATION TYPES
export const GET_OPERATION_TYPES_ATTEMPT = "GET_OPERATION_TYPES_ATTEMPT";
export const GET_OPERATION_TYPES_SUCCESS = "GET_OPERATION_TYPES_SUCCESS";
export const GET_OPERATION_TYPES_FAILURE = "GET_OPERATION_TYPES_FAILURE";

// AUDITS
export const GET_AUDITS_ATTEMPT = "GET_AUDITS_ATTEMPT";
export const GET_AUDITS_SUCCESS = "GET_AUDITS_SUCCESS";
export const GET_AUDITS_FAILURE = "GET_AUDITS_FAILURE";